let manualData = {
  salary: {},
  overpayment: {},
  interestRate: {},
};

export default manualData;
